import script from "./education.vue?vue&type=script&setup=true&lang=js"
export * from "./education.vue?vue&type=script&setup=true&lang=js"

import "./education.vue?vue&type=style&index=0&id=f464ac0c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f464ac0c"]])

export default __exports__